// ConfirmacionModal.jsx
import React from 'react';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogFooter,
  DialogTitle,
  DialogDescription,
} from '../UI/dialog';
import BotonAcceso from '../elementos/BotonAcceso';

const ModalConfirmacion = ({ show, handleClose, handleConfirm }) => {
  return (
    <Dialog open={show} onOpenChange={(open) => (!open ? handleClose() : null)}>
      <DialogContent className="max-w-md">
        <DialogHeader>
          <DialogTitle>Confirmación</DialogTitle>
          <DialogDescription>
            ¿Estás seguro de que deseas confirmar?
          </DialogDescription>
        </DialogHeader>
        <div className="flex items-center justify-center py-2">
          <div className="mx-auto w-16 h-16 bg-amber-100 rounded-full flex items-center justify-center">
            <svg className="w-8 h-8 text-amber-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L3.082 16.5c-.77.833.192 2.5 1.732 2.5z" />
            </svg>
          </div>
        </div>
        <DialogFooter className="gap-2">
          <BotonAcceso variant="dark" onClick={handleClose}>
            Cancelar
          </BotonAcceso>
          <BotonAcceso variant="accent" onClick={handleConfirm}>
            Confirmar
          </BotonAcceso>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default ModalConfirmacion;

